import { useTranslation } from 'react-i18next';
import { ContentAccordion } from '@zencity/common-survey/lib/content.mjs';
import { TitleText } from 'components/Content/Atoms/TitleText';
import { SecondaryText } from 'components/Content/Atoms/SecondaryText';
import { ContentContainer } from 'components/Content/Atoms/ContentContainer';
import { RenderMarkdownMarked } from 'components/Atoms/RenderMarkdownMarked/RenderMarkdownMarked';
import { ContentType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';

interface AccordionProps {
  content: ContentType;
}

export function Accordion(props: AccordionProps) {
  const { content } = props;
  const { translate } = useGetContentTranslations();
  const { t } = useTranslation();

  const description = translate(content.translations, 'description');
  const items = content.components.map((component) => ({
    id: component.id || '',
    title: translate(component.translations, 'title'),
    body: <RenderMarkdownMarked text={translate(component.translations, 'description')} />,
  }));

  return (
    <ContentContainer content={content}>
      <ContentAccordion
        items={items}
        expandAllLabel={t('accordion.expandAll')}
        collapseAllLabel={t('accordion.collapseAll')}
        heading={<TitleText text={translate(content.translations, 'label') || ' '} id={content.id} flush />}
        // Unlike other block headings' plain secondary text, an accordion's description renders
        // links and markdown, sanitized: authors use it to point residents at resources (ENG-4763).
        description={<SecondaryText text={description} flush markdown />}
        anchorId={content.id}
      />
    </ContentContainer>
  );
}
